<template>
  <div class="prompt-diff-viewer">
    <div
      v-for="(line, index) in diffLines"
      :key="index"
      class="diff-line"
      :class="lineClass(line)">
      <span class="diff-line-text">{{ line || ' ' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromptDiffViewer',
  props: {
    diff: {
      type: String,
      default: '',
    },
  },
  computed: {
    diffLines() {
      return (this.diff || '').replace(/\n$/, '').split('\n');
    },
  },
  methods: {
    lineClass(line) {
      if (line.startsWith('+++') || line.startsWith('---') || line.startsWith('@@')) {
        return 'diff-line--header';
      }
      if (line.startsWith('+')) return 'diff-line--add';
      if (line.startsWith('-')) return 'diff-line--del';
      return 'diff-line--context';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.prompt-diff-viewer {
  border: 1px solid $light-border;
  border-radius: 8px;
  overflow: hidden auto;
  max-height: 320px;
  background-color: $light-surface-2;

  .diff-line {
    padding: 2px 12px;

    .diff-line-text {
      font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
      font-size: $caption-1-size;
      line-height: 1.6;
      white-space: pre-wrap;
      word-break: break-word;
    }

    &--header {
      background-color: $light-surface-1;
      color: $light-foreground-4;
    }

    &--add {
      background-color: $light-success-light;
      color: $light-success-dark;
    }

    &--del {
      background-color: $light-error-light;
      color: $light-error-dark;
    }

    &--context {
      color: $light-foreground-3;
    }
  }
}
</style>
